import {Typography} from 'components/Typography';
import React, {FC} from 'react';
import style from './style.module.scss';
import classNames from 'classnames';

interface IProps {
    isInStock?: boolean;
}

export const ListVisualProductCardInStockLabel: FC<IProps> = ({isInStock}) => {
    if (!isInStock) {
        return null;
    }

    return (
        <div className={classNames(style.main, isInStock ? style.inStock : '')}>
            <div className={style.indicator} />
            <Typography className={style.text} variant={'label-10-b'}>
                в наличии
            </Typography>
        </div>
    );
};
